import React from "react";
import { Center, Stack } from "@mantine/core";
import { CustomText } from "../CustomText/CustomText";

const CustomEmptyState = ({
  height = 300,
  primary,
  secondary,
  primaryWeight = 500,
  primarySize = "lg",
  secondarySize = "sm",
  primaryColor = "dimmed",
  secondaryColor = "dimmed",
  stackAlign = "center",
  stackGap = "md",
  children,
  ...rest
}) => {
  return (
    <Center h={height} {...rest}>
      <Stack align={stackAlign} gap={stackGap}>
        {primary ? (
          <CustomText size={primarySize} fw={primaryWeight} c={primaryColor}>
            {primary}
          </CustomText>
        ) : null}
        {secondary ? (
          <CustomText size={secondarySize} c={secondaryColor}>
            {secondary}
          </CustomText>
        ) : null}
        {children}
      </Stack>
    </Center>
  );
};

export default CustomEmptyState;
